// API Request
// ------------------------------
export type CreateAffinityCategory = {
    name: string;
    description: string;
    inputType: string;
    condition: string;
    file: string;
    fileName: string;
    createdBy: number;
};

export type UpdateAffinityCategory = {
    id: number;
    description: string;
    usage: string;
    inputType: string;
    condition: string;
    file: string;
    fileName: string;
    updatedBy: number;
    expectedVersion: number;
};

export type DeleteAffinityCategory = {
    id: number;
    updatedBy: number;
    expectedVersion: number;
};

export type AffinityCategory = {
    id: number;
    name: string;
    description: string;
    uu: number;
    usage: string;
    inputType: string;
    condition: string;
    conditionJson: string;
    fileName: string;
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    updatedBy: number;
    accountGroupId: number;
};
 
// API Response
// ------------------------------
export type ResListAffinityCategories = {
    id: number;
    name: string;
    status: string;
    uu: number;
    inputType: string;
    usage: string;
    updatedAt: string;
    updatedBy: string;
};

export type ResGetAffinityCategory = {
    name: string;
    description: string;
    status: string;
    usage: string;
    inputType: string;
    fileName: string;
    uu: number;
    conditionJson: string;
    createdAt: string;
    createdBy: number;
    updatedAt: string;
    updatedBy: number;
    uploadedAt: string;
    version: number;
};

export type ResAvailableAffinityCategory = {
    id: number;
    name: string;
}

export const initResGetAffinityCategory: ResGetAffinityCategory = {
    name: "",
    description: "",
    status: "",
    usage: "",
    inputType: "",
    fileName: "",
    uu: 0,
    conditionJson: "",
    createdAt: "",
    createdBy: 0,
    updatedAt: "",
    updatedBy: 0,
    uploadedAt: "",
    version: 0,
};

export const AffinityProcessType = {
    create: "create",
    edit: "edit",
}